/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: false,
  apiUrl: 'https://adminuat.mindconnect.co.za/api',
  minimalApiUrl: 'https://adminuat.mindconnect.co.za',
  appUrl: 'https://superadminuat.mindconnect.co.za'
};
